import {
  BookCheck,
  BookOpenText,
  Clock,
  Star,
  Target,
  Video,
} from "lucide-react";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { Card, CardContent } from "../../components/ui/card";
import { useLanguage } from "../../context/LanguageContext";
import { DashboardData } from "../../lib/languages";
import { cn } from "./../../lib/utils";
import { Skeleton } from "src/components/ui/skeleton";
import { BaseUrlApi, ErrorMessage } from "../../lib/api";
import axios from "axios";
import { toast } from "sonner";
import AllLessons from "./../Teacher/Lesson/AllLessons";

// /student/lessons
const lessons = [
  {
    id: 65,
    bid: 6066461934,
    title: {
      ar: "كورس 1",
      en: "Lesson 1",
    },
    description: null,
    group: {
      id: 47,
      name: "Art Supplies",
      type: 0,
      users: [2],
      teacher: {
        id: 4,
        name: "Teacher",
        user_name: "teacher_userrr",
        email: "teacher@gmail.com",
        email_verified_at: null,
        phone: "123456789",
        role: "teacher",
        is_parent: 0,
        lang: "fr",
        image: "users/V0AYvWs6OmuMBLlsYtzlCAWiR6ViN3DvdH2f9iXR.png",
        provider: null,
        provider_id: null,
        created_at: null,
        updated_at: "2025-04-27T09:54:17.000000Z",
      },
      course: {
        id: 1,
        bid: 12345678,
        title: {
          en: '{"ar":"لوازم الفن","en":"Art Supplies"}',
        },
        description: {
          en: '{"ar":"مختلف مستلزمات الفن مثل الطلاء والفرشاة والقماش.","en":"Various art supplies like paints, brushes, and canvas."}',
        },
        sub_category_id: 1,
        status: 1,
        image: "courses/vRAKNaHIcEyL9gamsNR3rVoBubLu6VLqMIvSMEQS.png",
        video: null,
        created_by: 1,
        big_description: {
          en: '{"ar":"كتالوج تفصيلي لمستلزمات الفن.","en":"Detailed catalog of art supplies."}',
        },
        big_image: null,
        type: 1,
        created_at: "2025-04-13T13:16:00.000000Z",
        updated_at: "2025-04-15T12:06:19.000000Z",
      },
      level: {
        id: 1,
        bid: 10000010,
        title: {
          en: '{"en":"Introduction to Programming","ar":"\\u0645\\u0642\\u062f\\u0645\\u0629 \\u0641\\u064a \\u0627\\u0644\\u0628\\u0631\\u0645\\u062c\\u0629"}',
        },
        description: {
          en: '{"en":"A beginner-level course to help you understand programming basics.","ar":"\\u062f\\u0648\\u0631\\u0629 \\u0644\\u0644\\u0645\\u0628\\u062a\\u062f\\u0626\\u064a\\u0646 \\u062a\\u0633\\u0627\\u0639\\u062f\\u0643 \\u0639\\u0644\\u0649 \\u0641\\u0647\\u0645 \\u0623\\u0633\\u0627\\u0633\\u064a\\u0627\\u062a \\u0627\\u0644\\u0628\\u0631\\u0645\\u062c\\u0629."}',
        },
        course_id: 1,
        created_by: 1,
        created_at: "2025-04-13T13:16:00.000000Z",
        updated_at: "2025-04-13T13:16:00.000000Z",
      },
      price: {
        id: 1,
        bid: 1307444391,
        name: "Premium Plan",
        price: "999.00",
        status: 1,
        currency: {
          id: 70,
          country: "Egypt",
          currency: "Egyptian Pound",
          code: "EGP",
          minor_unit: 2,
          symbol: null,
          created_at: null,
          updated_at: null,
        },
        discount: "12.00",
        duration: "23:00:00",
        group_num: 4,
        lesson_num: 1,
        type: "group",
        user: {
          id: 4,
          name: "Teacher",
          user_name: "teacher_userrr",
          email: "teacher@gmail.com",
          email_verified_at: null,
          phone: "123456789",
          role: "teacher",
          is_parent: 0,
          lang: "fr",
          image: "users/V0AYvWs6OmuMBLlsYtzlCAWiR6ViN3DvdH2f9iXR.png",
          provider: null,
          provider_id: null,
          created_at: null,
          updated_at: "2025-04-27T09:54:17.000000Z",
        },
        price_feature: [
          {
            id: 2,
            bid: 6436946623,
            price_id: 1,
            description: "the best price ever",
            created_at: "2025-04-24T12:50:28.000000Z",
            updated_at: "2025-04-24T12:50:28.000000Z",
          },
        ],
        created_at: "2025-04-13T14:51:54.000000Z",
        updated_at: "2025-04-13T14:51:54.000000Z",
      },
      promocode: null,
      payment: null,
      price_lesson: null,
      created_at: "2025-04-24T12:59:42.000000Z",
      updated_at: "2025-04-24T12:59:42.000000Z",
    },
    status: 1,
    image: "lessons/jnIqZQKv2EMJiBEDVWxZIIHfmiUyWAY8stpmt6dO.png",
    booking: {
      id: 61,
      bid: 2694805153,
      student_id: 2,
      teacher_availability_id: {
        id: 5,
        teacher: "Teacher",
        day_of_week: "Monday",
        start_time: "10:15:00",
        end_time: "11:04:00",
        start_date: "2025-04-15",
        end_date: "2025-04-30",
        is_recurring: 0,
        created_at: "2025-04-13T14:50:39.000000Z",
      },
      start_time: "10:04:00",
      end_time: "11:03:00",
      level_id: 1,
      date: "2025-04-15",
      created_at: "2025-04-24T12:59:41.000000Z",
      updated_at: "2025-04-24T12:59:41.000000Z",
    },
    all_assignments_answered: null,
    all_quizzes_attempted: null,
    created_at: "2025-04-24T12:59:42.000000Z",
    updated_at: "2025-04-24T14:08:38.000000Z",
  },
];

// /student/courses
const courses = [
  {
    id: 1,
    bid: 12345678,
    title: {
      ar: "لوازم الفن",
      en: "Art Supplies",
    },
    description: {
      ar: "مختلف مستلزمات الفن مثل الطلاء والفرشاة والقماش.",
      en: "Various art supplies like paints, brushes, and canvas.",
    },
    sub_category: {
      id: 1,
      title: {
        en: "Programming Books",
        ar: "كتب البرمجة",
      },
      description: {
        en: "Books about programming languages, frameworks, and development techniques.",
        ar: "كتب عن لغات البرمجة والأطر وتقنيات التطوير.",
      },
      category: {
        id: 1,
        title: {
          en: "Programming",
          ar: "البرمجة",
        },
        description: {
          en: "All programming related courses",
          ar: "جميع الدورات المتعلقة بالبرمجة",
        },
        created_by: {
          id: 1,
          name: "Almadbwly",
          user_name: "admin_user",
          email: "ahmedalmadbwly@gmail.com",
          phone: "123-456-7890",
          role: "teacher",
          is_parent: 0,
          lang: "en",
          image: null,
          provider: null,
          provider_id: null,
          created_at: null,
          updated_at: "2025-04-16T13:35:48.000000Z",
        },
        image: "categories/programming.png",
        status: 1,
        sub_category_count: 2,
        created_at: "2025-04-13 13:16:00",
        updated_at: "2025-04-13 13:16:00",
      },
      status: 1,
      image: null,
      course_count: 1,
      created_by: {
        id: 1,
        name: "Almadbwly",
        user_name: "admin_user",
        email: "ahmedalmadbwly@gmail.com",
        phone: "123-456-7890",
        role: "teacher",
        is_parent: 0,
        lang: "en",
        image: null,
        provider: null,
        provider_id: null,
        created_at: null,
        updated_at: "2025-04-16T13:35:48.000000Z",
      },
      created_at: "2025-04-13 13:16:00",
      updated_at: "2025-04-13 13:16:00",
    },
    status: 1,
    image: "courses/vRAKNaHIcEyL9gamsNR3rVoBubLu6VLqMIvSMEQS.png",
    video: null,
    created_by: {
      id: 1,
      name: "Almadbwly",
      user_name: "admin_user",
      email: "ahmedalmadbwly@gmail.com",
      phone: "123-456-7890",
      role: "teacher",
      is_parent: 0,
      lang: "en",
      image: null,
      provider: null,
      provider_id: null,
      created_at: null,
      updated_at: "2025-04-16T13:35:48.000000Z",
    },
    level_count: 2,
    big_description: {
      ar: "كتالوج تفصيلي لمستلزمات الفن.",
      en: "Detailed catalog of art supplies.",
    },
    big_image: null,
    type: 1,
    levels: [
      {
        id: 1,
        bid: 10000010,
        title: {
          en: "Introduction to Programming",
          ar: "مقدمة في البرمجة",
        },
        description: {
          en: "A beginner-level course to help you understand programming basics.",
          ar: "دورة للمبتدئين تساعدك على فهم أساسيات البرمجة.",
        },
        created_by: {
          id: 1,
          name: "Almadbwly",
          user_name: "admin_user",
          email: "ahmedalmadbwly@gmail.com",
          phone: "123-456-7890",
          role: "teacher",
          is_parent: 0,
          lang: "en",
          image: null,
          provider: null,
          provider_id: null,
          created_at: null,
          updated_at: "2025-04-16T13:35:48.000000Z",
        },
        course: {
          id: 1,
          bid: 12345678,
          title: {
            en: '{"ar":"لوازم الفن","en":"Art Supplies"}',
          },
          description: {
            en: '{"ar":"مختلف مستلزمات الفن مثل الطلاء والفرشاة والقماش.","en":"Various art supplies like paints, brushes, and canvas."}',
          },
          sub_category_id: 1,
          status: 1,
          image: "courses/vRAKNaHIcEyL9gamsNR3rVoBubLu6VLqMIvSMEQS.png",
          video: null,
          created_by: 1,
          big_description: {
            en: '{"ar":"كتالوج تفصيلي لمستلزمات الفن.","en":"Detailed catalog of art supplies."}',
          },
          big_image: null,
          type: 1,
          created_at: "2025-04-13T13:16:00.000000Z",
          updated_at: "2025-04-15T12:06:19.000000Z",
        },
        groups_count: 1,
        groups: [
          {
            id: 47,
            name: "Art Supplies",
            type: 0,
            users_id: [2],
            teacher_id: 4,
            course_id: 1,
            level_id: 1,
            price_id: 1,
            promocode_id: null,
            payment_id: 40,
            created_at: "2025-04-24T12:59:42.000000Z",
            updated_at: "2025-04-24T12:59:42.000000Z",
            price_after_rate: null,
          },
        ],
        created_at: "2025-04-13 13:16:00",
        updated_at: "2025-04-13 13:16:00",
      },
      {
        id: 3,
        bid: 10032323,
        title: {
          en: "Art of UI/UX Design",
          ar: "فن تصميم واجهة المستخدم وتجربة المستخدم",
        },
        description: {
          en: "Learn the core principles of designing efficient and user-friendly interfaces.",
          ar: "تعلم المبادئ الأساسية لتصميم واجهات فعالة وسهلة الاستخدام.",
        },
        created_by: {
          id: 1,
          name: "Almadbwly",
          user_name: "admin_user",
          email: "ahmedalmadbwly@gmail.com",
          phone: "123-456-7890",
          role: "teacher",
          is_parent: 0,
          lang: "en",
          image: null,
          provider: null,
          provider_id: null,
          created_at: null,
          updated_at: "2025-04-16T13:35:48.000000Z",
        },
        course: {
          id: 1,
          bid: 12345678,
          title: {
            en: '{"ar":"لوازم الفن","en":"Art Supplies"}',
          },
          description: {
            en: '{"ar":"مختلف مستلزمات الفن مثل الطلاء والفرشاة والقماش.","en":"Various art supplies like paints, brushes, and canvas."}',
          },
          sub_category_id: 1,
          status: 1,
          image: "courses/vRAKNaHIcEyL9gamsNR3rVoBubLu6VLqMIvSMEQS.png",
          video: null,
          created_by: 1,
          big_description: {
            en: '{"ar":"كتالوج تفصيلي لمستلزمات الفن.","en":"Detailed catalog of art supplies."}',
          },
          big_image: null,
          type: 1,
          created_at: "2025-04-13T13:16:00.000000Z",
          updated_at: "2025-04-15T12:06:19.000000Z",
        },
        groups_count: 0,
        groups: [],
        created_at: "2025-04-13 13:16:00",
        updated_at: "2025-04-13 13:16:00",
      },
    ],
    rate: null,
    created_at: "2025-04-13 13:16:00",
    updated_at: "2025-04-15 12:06:19",
  },
];

// /student/schedule
const schedule = [
  {
    id: 61,
    course_name: {
      ar: "لوازم الفن",
      en: "Art Supplies",
    },
    teacher_name: "Teacher",
    date: "2025-04-15",
    start_time: "10:04:00",
    end_time: "11:03:00",
  },
  {
    id: 62,
    course_name: {
      en: "Graphic Design Tools",
      ar: "أدوات التصميم الجرافيكي",
    },
    teacher_name: "Teacher",
    date: "2025-04-13",
    start_time: "13:04:00",
    end_time: "14:03:00",
  },
];

// /student/payments
const invoices = [
  {
    id: 40,
    user_id: 2,
    paypal_id: 57,
    myfatoorah_id: null,
    amount: 999,
    status: "completed",
    created_at: "2025-04-24T12:59:41.000000Z",
    updated_at: "2025-04-24T12:59:41.000000Z",
    myfatoorah: null,
    paypal: {
      id: 57,
      payer_name: "John Doe",
      payer_email: "sb-bugsd40145563@personal.example.com",
      amount: 999,
      account_id: "DNEQ757JL8LRU",
      transaction_id: "8NM21918R39858225",
      created_at: "2025-04-24T12:59:38.000000Z",
      updated_at: "2025-04-24T12:59:38.000000Z",
    },
  },
  {
    id: 41,
    user_id: 2,
    paypal_id: 58,
    myfatoorah_id: null,
    amount: 999,
    status: "completed",
    created_at: "2025-04-27T13:02:20.000000Z",
    updated_at: "2025-04-27T13:02:20.000000Z",
    myfatoorah: null,
    paypal: {
      id: 58,
      payer_name: "John Doe",
      payer_email: "sb-bugsd40145563@personal.example.com",
      amount: 999,
      account_id: "DNEQ757JL8LRU",
      transaction_id: "9M974310A1124384L",
      created_at: "2025-04-27T13:02:16.000000Z",
      updated_at: "2025-04-27T13:02:16.000000Z",
    },
  },
];

// /student/quizzes
const quizzes = [
  {
    id: 32,
    bid: 9293178401,
    title: {
      en: '{"en":"Quiz 1","ar":"اختبار 1"}',
    },
    description: {
      en: '{"en":"<p dir=\\"ltr\\">Quiz 1</p>","ar":""}',
    },
    duration: "01:00:00",
    lesson_id: 65,
    course_id: null,
    category_id: null,
    created_by: 4,
    start_date: "2025-04-24 00:00:00",
    end_date: "2025-04-25 01:00:00",
    created_at: "2025-04-24T14:10:15.000000Z",
    updated_at: "2025-04-24T14:10:15.000000Z",
    show_answer: 1,
    show_degree: 1,
    has_attempted: true,
    total_score: 10,
    lesson: {
      id: 65,
      bid: 6066461934,
      title: {
        en: '{"ar":"كورس 1","en":"Lesson 1"}',
      },
      description: null,
      enroll_course_id: 47,
      status: 1,
      image: "lessons/jnIqZQKv2EMJiBEDVWxZIIHfmiUyWAY8stpmt6dO.png",
      created_at: "2025-04-24T12:59:42.000000Z",
      updated_at: "2025-04-24T14:08:38.000000Z",
      student_book_id: 61,
      enroll_course: {
        id: 47,
        name: "Art Supplies",
        type: 0,
        users_id: [2],
        teacher_id: 4,
        course_id: 1,
        level_id: 1,
        price_id: 1,
        promocode_id: null,
        payment_id: 40,
        created_at: "2025-04-24T12:59:42.000000Z",
        updated_at: "2025-04-24T12:59:42.000000Z",
        price_after_rate: null,
      },
    },
    quiz_attempts: [
      {
        id: 32,
        bid: 8088838193,
        user_id: 2,
        quiz_id: 32,
        score: "10.00",
        isCompleted: null,
        created_at: "2025-04-24T14:22:10.000000Z",
        updated_at: "2025-04-24T14:22:10.000000Z",
      },
    ],
  },
];

// /student/assignments
const assignments = [
  {
    id: 5,
    bid: 8300685654,
    title: {
      ar: "الواجب 1",
      en: "Homework 1",
    },
    description: {
      ar: '<p dir="rtl">الواجب 1</p>',
      en: '<p dir="ltr">Homework 1</p>',
    },
    files: ["home-work/M1II7xsaQMAahJzbtioNuTkYbPnAORbaaLsHqRfG.jpg"],
    link: null,
    score: "4.00",
    lesson_id: 65,
    max_items: 2,
    due_date: "2025-04-25",
    all_student: 0,
    answers: [],
    created_at: "2025-04-24 14:09:34",
    updated_at: "2025-04-24 14:09:34",
  },
];

const SkeletonCard = ({ height = "h-16" }) => (
  <div className="space-y-4">
    <Skeleton className={`${height} w-full`} />
    <Skeleton className={`${height} w-full`} />
  </div>
);

export default function UserDashboard() {
  const { language } = useLanguage();
  const t = DashboardData[language] || DashboardData["en"];

  const [loadingLessons, setLoadingLessons] = useState(true);
  const [lessons, setLessons] = useState([]);
  const AllLessons = () => {
    axios
      .get(`${BaseUrlApi}/student/lessons`)
      .then(({ data }) => {
        setLessons(data.data);
      })
      .catch((error) => {
        toast("Error loading lessons", {
          description: ErrorMessage(error),
        });
      })
      .finally(() => setLoadingLessons(false));
  };

  const [loadingCourses, setLoadingCourses] = useState(true);
  const [courses, setCourses] = useState([]);
  const getAllCourses = async () => {
    try {
      const { data } = await axios.get(`${BaseUrlApi}/student/courses`);
      setCourses(data.data);
    } catch (error) {
      toast("Error", {
        description: ErrorMessage(error),
      });
    } finally {
      setLoadingCourses(false);
    }
  };

  const [loadingInvoices, setLoadingInvoices] = useState(true);
  const [invoices, setInvoices] = useState([]);
  const fetchInvoices = async () => {
    try {
      const { data } = await axios.get(`${BaseUrlApi}/student/payments`);
      setInvoices(data.data);
    } catch (error) {
      const result = ErrorMessage(error);
      if (typeof result !== "object")
        toast({ title: "Error", description: result });
    } finally {
      setLoadingInvoices(false);
    }
  };

  const [loadingSchedule, setLoadingSchedule] = useState(true);
  const [schedule, setSchedule] = useState([]);
  const fetchSchedule = async () => {
    try {
      const { data } = await axios.get(`${BaseUrlApi}/student/schedule`);
      setSchedule(data.data);
    } catch (error) {
      const result = ErrorMessage(error);
      if (typeof result !== "object")
        toast({ title: "Error", description: result });
    } finally {
      setLoadingSchedule(false);
    }
  };

  const [loadingQuizzes, setLoadingQuizzes] = useState(true);
  const [quizzes, setQuizzes] = useState([]);
  const getAllQuizzes = async () => {
    try {
      const { data } = await axios.get(`${BaseUrlApi}/student/quizzes`);
      setQuizzes(data.data);
    } catch (error) {
      toast("Error", { description: ErrorMessage(error) });
    } finally {
      setLoadingQuizzes(false);
    }
  };

  const [loadingAssignments, setLoadingAssignments] = useState(true);
  const [assignments, setAssignments] = useState([]);
  const fetchAssignments = async () => {
    try {
      const { data } = await axios.get(`${BaseUrlApi}/student/assignments`);
      setAssignments(data.data);
    } catch (error) {
      const result = ErrorMessage(error);
      if (typeof result !== "object") toast("Error", { description: result });
    } finally {
      setLoadingAssignments(false);
    }
  };

  useEffect(() => {
    AllLessons();
    getAllCourses();
    fetchInvoices();
    fetchSchedule();
    getAllQuizzes();
    fetchAssignments();
  }, []);

  // compute how many have been submitted
  const submittedCount = assignments.filter(
    (hw) => (hw.answers?.length || 0) > 0
  ).length;
  const totalCount = assignments.length;

  return (
    <div className="space-y-6" dir={language === "ar" ? "rtl" : "ltr"}>
      <div className="grid lg:grid-cols-3 gap-6">
        {/* Left */}
        <div className="lg:col-span-2 space-y-6">
          {/* Daily Lessons */}
          <div className="space-y-4">
            <div className="flex items-center justify-between gap-2">
              <p className="font-semibold text-lg">{t.dailyLessons}</p>
              <Button
                variant="link"
                className="underline text-muted-foreground p-0"
                asChild
              >
                <Link to="/lessons">{t.showMoreLessons}</Link>
              </Button>
            </div>
            {loadingLessons ? (
              <SkeletonCard />
            ) : (
              <DailyLessonsList lessons={lessons} />
            )}
          </div>
          {/* Registered courses */}
          <div className="space-y-4">
            <div className="flex items-center justify-between gap-2">
              <p className="font-semibold text-lg">{t.registeredCourses}</p>
              <Button
                variant="link"
                className="underline text-muted-foreground p-0"
                asChild
              >
                <Link to="/my-courses/current">{t.showMoreCourses}</Link>
              </Button>
            </div>
            {loadingCourses ? (
              <SkeletonCard />
            ) : (
              <RegisteredCoursesList courses={courses} />
            )}
          </div>
        </div>

        {/* Right */}
        <div className="lg:col-span-1 space-y-4">
          {/* All Courses not rated BTN */}
          <Button
            className="w-full capitalize flex items-center justify-between h-11 rounded-xl"
            variant="outline"
            asChild
          >
            <Link to="/my-courses/current">
              <span>{t.rateTheCourses}</span>
              <div className="relative flex">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-yellow-500 opacity-75" />
                <Star fill="#eab308" color="#eab308" />
              </div>
            </Link>
          </Button>

          {/* Invoices */}
          <Card className="h-fit">
            <CardContent className="p-4 space-y-4">
              <div className="flex items-center justify-between gap-2">
                <p className="font-semibold text-lg">{t.invoices}</p>
                <Button
                  variant="link"
                  className="underline text-muted-foreground p-0"
                  asChild
                >
                  <Link to="/invoices">{t.showMoreInvoices}</Link>
                </Button>
              </div>
              {loadingInvoices ? (
                <SkeletonCard />
              ) : (
                <InvoicesList invoices={invoices} />
              )}
            </CardContent>
          </Card>
        </div>
      </div>

      {/* Daily schedule */}
      <div className="space-y-4">
        <p className="font-semibold text-lg">{t.dailySchedule}</p>
        {loadingSchedule ? (
          <SkeletonCard />
        ) : (
          <DailyScheduleList schedule={schedule} />
        )}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {/* Tests */}
        <div className="space-y-4">
          <div className="flex items-center justify-between gap-2">
            <p className="font-semibold text-lg">{t.quizzes}</p>
            <Button
              variant="link"
              className="underline text-muted-foreground p-0"
              asChild
            >
              <Link to="/quizzes">{t.showMoreQuizzes}</Link>
            </Button>
          </div>
          {loadingQuizzes ? (
            <SkeletonCard height="h-28" />
          ) : (
            <QuizzesList quizzes={quizzes} />
          )}
        </div>

        {/* Academic assignment */}
        <div className="space-y-4 mt-2">
          <div className="flex items-center justify-between gap-2">
            <p className="font-semibold text-lg">{t.academicAssignment}</p>
            <p className="font-bold text-lg">
              <span
                className={cn(
                  submittedCount === totalCount
                    ? "text-green-500"
                    : "text-red-500"
                )}
              >
                {submittedCount}
              </span>
              /{totalCount}
            </p>
          </div>
          <Card className="h-fit">
            <CardContent className="p-4 space-y-4">
              {loadingAssignments ? (
                <SkeletonCard />
              ) : (
                <AcademicAssignmentList assignments={assignments} />
              )}
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}

const DailyLessonsList = ({ lessons }) => {
  const { language } = useLanguage();
  const t = DashboardData[language] || DashboardData["en"];

  const today = new Date().toISOString().split("T")[0];

  const todaysLessons = lessons.filter((lesson) => {
    const lessonDate = lesson?.booking?.date;
    return lessonDate === today;
  });

  const getDuration = (lesson) => {
    return lesson?.group?.price?.duration || "N/A";
  };

  const getTimeRange = (lesson) => {
    const start = lesson?.booking?.start_time;
    const end = lesson?.booking?.end_time;
    return start && end ? `${start} - ${end}` : "N/A";
  };

  const getTitle = (lesson) => {
    return lesson?.title?.en || lesson?.title?.ar || "No Title";
  };

  return (
    <div className="grid gap-4">
      {todaysLessons.length > 0 ? (
        todaysLessons.slice(0, 2).map((lesson) => (
          <Card key={lesson.id}>
            <CardContent className="p-4 grid grid-cols-2 md:grid-cols-4 items-center gap-4">
              <div className="flex items-center gap-2 col-span-2 overflow-hidden">
                <div className="min-w-11 h-11 rounded-full flex items-center justify-center text-white bg-blue-600">
                  <Video />
                </div>
                <p className="text-base">{getTitle(lesson)}</p>
              </div>

              <div>
                <p className="text-muted-foreground text-xs">{t.duration}</p>
                <p className="font-semibold text-sm">{getDuration(lesson)}</p>
              </div>

              <div className="text-end">
                <p className="text-muted-foreground text-xs">{t.time}</p>
                <p
                  className={`font-semibold text-sm ${
                    lesson.isLive ? "text-red-500" : ""
                  }`}
                >
                  {getTimeRange(lesson)}
                </p>
              </div>
            </CardContent>
          </Card>
        ))
      ) : (
        <div className="text-center py-8 text-gray-500">
          {t.noLessonsToday || "No lessons today"}
        </div>
      )}
    </div>
  );
};

const RegisteredCoursesList = ({ courses }) => {
  const { language } = useLanguage();
  const t = DashboardData[language] || DashboardData["en"];

  if (!courses || courses.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        {t.noCourses || "No courses to display"}
      </div>
    );
  }

  const getTitle = (course) =>
    course?.title?.en ||
    course?.title?.ar ||
    course?.sub_category?.title?.en ||
    "Untitled Course";

  const getSubcategory = (course) =>
    course?.sub_category?.title?.en ||
    course?.sub_category?.title?.ar ||
    "General Category";

  const getTeacher = (course) => course?.created_by?.name || "Unknown Teacher";

  const getType = (course) => {
    if (course?.type === 1) return "Live";
    if (course?.type === 0) return "Recorded";
    return "Unknown";
  };

  return (
    <div className="grid gap-4">
      {courses.slice(0, 2).map((course) => (
        <Card key={course.id}>
          <CardContent className="p-4 grid grid-cols-2 md:grid-cols-4 items-center gap-4">
            {/* Title + Subcategory */}
            <div className="flex items-center gap-2 col-span-2">
              <div className="min-w-11 h-11 rounded-full flex items-center justify-center text-white bg-blue-600">
                <BookOpenText />
              </div>
              <div>
                <p className="text-base">{getTitle(course)}</p>
                <p className="text-xs text-muted-foreground">
                  {getSubcategory(course)}
                </p>
              </div>
            </div>

            {/* Teacher */}
            <div>
              <p className="text-muted-foreground text-xs">
                {t.teacher || "Teacher"}
              </p>
              <p className="font-semibold text-sm">{getTeacher(course)}</p>
            </div>

            {/* Type */}
            <div className="flex items-center gap-2 justify-end">
              <div>
                <p className="text-muted-foreground text-xs">
                  {t.type || "Type"}
                </p>
                <p className="font-semibold text-sm">{getType(course)}</p>
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

const DailyScheduleList = ({ schedule }) => {
  const { language } = useLanguage();
  const t = DashboardData[language] || DashboardData["en"];

  if (!schedule || schedule.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        {t.noSchedule || "No schedule items to display"}
      </div>
    );
  }

  const fmtDate = (iso) =>
    new Date(iso).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });

  return (
    <div className="space-y-4">
      {schedule.slice(0, 2).map((item) => (
        <Card key={item.id}>
          <CardContent className="grid grid-cols-2 md:grid-cols-4 items-center gap-4 p-4">
            {/* title + date */}
            <div className="flex items-center gap-2 col-span-2">
              <div className="min-w-10 h-10 rounded-xl flex items-center justify-center text-white bg-blue-600">
                <Target />
              </div>
              <div className="space-y-1">
                <p className="text-sm">
                  {item.course_name[language] || item.course_name.en}
                </p>
                <p className="text-muted-foreground text-xs">
                  {fmtDate(item.date)}
                </p>
              </div>
            </div>

            {/* duration */}
            <div>
              <p className="text-muted-foreground text-xs">{t.duration}</p>
              <p className="font-semibold text-sm">
                {`${item.start_time} - ${item.end_time}`}
              </p>
            </div>

            {/* instructor */}
            <div className="text-end">
              <p className="text-muted-foreground text-xs">{t.instructor}</p>
              <p className="font-semibold text-sm">
                {item.teacher_name || "TBA"}
              </p>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

const InvoicesList = ({ invoices }) => {
  const { language } = useLanguage();
  const t = DashboardData[language] || DashboardData["en"];

  if (!invoices || invoices.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        {t.noInvoices || "No invoices to display"}
      </div>
    );
  }

  // Format ISO → "Apr 24, 2025"
  const fmtDate = (iso) =>
    new Date(iso).toLocaleDateString(language, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });

  // Fallback price formatter
  const fmtPrice = (amt = 0) =>
    new Intl.NumberFormat(language, {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    }).format(amt);

  // Determine method type
  const getMethodType = (inv) => {
    if (inv.paypal_id) return "PayPal";
    if (inv.myfatoorah_id) return "MyFatoorah";
    return "Unknown";
  };

  return (
    <div className="space-y-4">
      {invoices.slice(0, 4).map((inv) => (
        <div key={inv.id}>
          <div className="flex items-center justify-between gap-4">
            {/* Invoice Title / Payer */}
            <p
              className={`text-sm font-semibold ${
                inv.status !== "completed" ? "text-red-500" : ""
              }`}
            >
              {inv.paypal?.payer_name || `Invoice #${inv.id}`}
            </p>

            {/* Payment Method */}
            <div className="text-center">
              <p className="text-muted-foreground text-xs">
                {t.method || "Method"}
              </p>
              <p className="font-semibold text-sm">{getMethodType(inv)}</p>
            </div>

            {/* Amount + Date */}
            <div className="text-right space-y-1">
              <p className="text-sm font-semibold">{fmtPrice(inv?.amount)}</p>
              <p className="text-muted-foreground text-xs">
                {fmtDate(inv.created_at)}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

const AcademicAssignmentList = ({ assignments }) => {
  const { language } = useLanguage();
  const t = DashboardData[language] || DashboardData["en"];

  if (!assignments || assignments.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        {t.noAssignments || "No assignments to display"}
      </div>
    );
  }

  // e.g. "2025-04-25" → "Apr 25, 2025"
  const fmtDate = (iso) =>
    new Date(iso).toLocaleDateString(language, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });

  return (
    <div className="space-y-4">
      {assignments.map((hw) => {
        const title = hw.title[language] || hw.title.en;
        const date = fmtDate(hw.due_date);
        const isReceived = (hw.answers?.length || 0) > 0;
        const type = isReceived
          ? t.submitted || "Submitted"
          : t.pending || "Pending";

        return (
          <div
            key={hw.id}
            className="flex items-center gap-4 justify-between flex-nowrap lg:flex-wrap xl:flex-nowrap"
          >
            {/* icon + title & date */}
            <div className="flex items-center gap-2">
              <div className="min-w-10 h-10 rounded-full flex items-center justify-center text-white bg-blue-600">
                <BookCheck />
              </div>
              <div className="space-y-1">
                <p className="text-sm">{title}</p>
                <p className="text-muted-foreground text-xs">{date}</p>
              </div>
            </div>

            {/* status pill */}
            <div className="flex w-fit lg:w-full xl:w-fit justify-end">
              <div
                className={`shadow-md text-sm text-center dark:shadow-gray-900 border rounded-xl py-1 px-2 font-semibold ${
                  isReceived ? "text-green-500" : "text-blue-500"
                }`}
              >
                {type}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

const QuizzesList = ({ quizzes }) => {
  const { language } = useLanguage();
  const t = DashboardData[language] || DashboardData["en"];

  if (!quizzes || quizzes.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        {t.noQuizzes || "No quizzes to display"}
      </div>
    );
  }

  // Safely parse JSON-encoded fields
  const parseJSON = (str) => {
    try {
      return JSON.parse(str);
    } catch {
      return {};
    }
  };

  // Format date/time
  const fmtDateTime = (iso) =>
    new Date(iso).toLocaleString(language, {
      dateStyle: "medium",
      timeStyle: "short",
    });

  return (
    <div className="grid">
      {quizzes.slice(0, 4).map((quiz) => {
        const titleObj = parseJSON(quiz.title.en);
        const descObj = parseJSON(quiz.description.en);
        const lessonObj = parseJSON(quiz.lesson.title.en);
        const title = titleObj[language] || titleObj.en || "Quiz";
        const desc = descObj[language] || descObj.en || "";
        const lessonTitle = lessonObj[language] || lessonObj.en || "";
        const date = fmtDateTime(quiz.start_date);

        // compute score%
        const attempt = quiz.quiz_attempts?.[0];
        const scoreRaw = attempt ? parseFloat(attempt.score) : 0;
        const totalRaw = quiz.total_score || 0;
        const degree =
          totalRaw > 0 ? Math.round((scoreRaw / totalRaw) * 100) : 0;
        const remark =
          degree >= 90
            ? t.excellent || "Excellent"
            : degree >= 50
            ? t.good || "Good"
            : t.repeatTest || "Please repeat the test";
        const hue = degree >= 50 ? "green" : "red";

        return (
          <Card key={quiz.id} className="overflow-hidden">
            {/* Card Header */}
            <div className="bg-blue-600 text-white px-4 py-2 text-sm font-semibold">
              {title}
            </div>

            <CardContent className="p-4 space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Left side: description & meta */}
                <div className="space-y-2">
                  <div
                    className="text-base font-medium"
                    dangerouslySetInnerHTML={{ __html: desc }}
                  />
                  <p className="text-sm text-muted-foreground">{lessonTitle}</p>
                  <div className="inline-flex items-center text-xs text-blue-600 border border-blue-600 rounded-full px-2 py-1">
                    <Clock size={14} />
                    <span className="ml-1">{date}</span>
                  </div>
                </div>

                {/* Right side: progress bar & remark */}
                <div className="flex flex-col justify-between items-center md:items-end space-y-3">
                  {/* Numeric score */}
                  <p className={`text-xl font-bold text-${hue}-600`}>
                    {degree}%
                  </p>

                  {/* Horizontal progress bar */}
                  <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
                    <div
                      className={`h-full bg-${hue}-500`}
                      style={{ width: `${degree}%` }}
                    />
                  </div>

                  {/* Remark badge */}
                  <span
                    className={`inline-block bg-${hue}-100 text-${hue}-800 text-xs font-semibold px-3 py-1 rounded-full`}
                  >
                    {remark}
                  </span>
                </div>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};
